import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { ROUTES } from '../constants/routes';
import { useAuth } from '../store/authStore';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth();
  if (isLoading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0f0f12' }}>
      <div style={{ width: 40, height: 40, borderRadius: '50%', border: '3px solid #333', borderTopColor: '#6c63ff', animation: 'spin 0.7s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
  return user ? <>{children}</> : <Navigate to={ROUTES.LOGIN} replace />;
}
